import axios from 'axios';

import BaseService from "./BaseService";
import LogUtils from "../utils/LogUtils";
import settings from "../settings/settings";

class AddressService extends BaseService {

  constructor() {
    super();
    this.TAG = "AddressService";

    this.logUtils = new LogUtils();
  }

  async getAddressByInfo({countryId, stateId, cityId, neighborhood, street, number, 
                          zipCode, additionalInfo}) {
    let address = {};

    try {
      const response = this.getResponse(await axios(this.getBasicHttpRequest(
        this.HTTP_METHODS.GET,
        `${settings.MANAGEMENT_SERVICE_URL}/addresses?countryId=${countryId}&stateId=${stateId}&cityId=${cityId}&neighborhood=${neighborhood}&street=${street}&number=${number}&zipCode=${zipCode}&additionalInfo=${additionalInfo}`,
        this.getDefaultHeaders(true)
      )));

      if (response.status !== 1) {
        return {
          status: 0,
          msg: "Não foi possível retornar informações sobre o endereço."
        };
      }

      if (!response.data) {
        return {
          status: -1,
          msg: "Não foi possível retornar informações sobre o endereço."
        };
      }

      address = response.data;

    } catch (err) {
      this.logUtils.logErrorMsg(this.TAG, "Unabled to getAddressByInfo", err);

      return {
        status: -2,
        msg: "Não foi possível retornar informações sobre o endereço"
      };
    }

    return {
      status: 1,
      msg: "As informações sobre o endereço foram retornadas com sucesso.",
      data: address
    };
  }

  async upsertAddress({countryId, stateId, cityId, neighborhood, street, number, zipCode, additionalInfo}) {
    let address = null;

    try {
      const response = this.getResponse(await axios(
        this.getBasicHttpRequest(this.HTTP_METHODS.POST,
          `${settings.MANAGEMENT_SERVICE_URL}/addresses/upsert/`,
          this.getDefaultHeaders(true, true),
          {
            countryId: countryId,
            stateId: stateId,
            cityId: cityId,
            neighborhood: neighborhood,
            street: street,
            number: number,
            zipCode: zipCode,
            additionalInfo: additionalInfo,
            cityRegionId: null,
            cityNeighborhoodId: null,
            belongsToPerson: null,
            geoLocationId: null,
            lat: null,
            lng: null,
            placeId: null
          },
          true
        )));

      if (response.status !== 1) {
        return {
          status: 0,
          msg: response.error ? response.error : "Não foi possível criar ou atualizar o endereço."
        };
      }

      if (!response.data) {
        return {
          status: -1,
          msg: "Houve um erro ao processar a operação."
        };
      }

      address = response.data;

    } catch (err) {
      this.logUtils.logErrorMsg(this.TAG, "Unabled to upsertAddress", err);

      return {
        status: -2,
        msg: "Não foi possível criar ou atualizar o endereço"
      };
    }

    return {
      status: 1,
      msg: "Endereço criado ou atualizado com sucesso.",
      data: address
    };
  }

}

export default AddressService;